import { fetchData } from "@client";

export async function checkIfLibraryElementExistsQuery(elementId) {
  const res = await fetchData(`/v1/library/${elementId}/exists`);
  return !!res.results?.[0];
}
